<form [formGroup]="specialApplianceFG" class="component-container special-appliance-container">
  <div class="ui-g top-border">
    <div class="ui-g-12 form-rows relative-position">
      <div class="ui-g-6 field-rows">
        <label
          class="ui-g-6 field-label text-right-align"
          [class.required]="isSpecialApplianceSectionRequired"
          for="base-data-special-appliance">
          {{ 'facilities-data.form-fields.special-appliance' | translate }}
        </label>
        <p-dropdown
          (onChange)="selectSpecialAppliance($event)"
          [options]="specialAppliances"
          formControlName="specialAppliance"
          [readonly]="isReadOnly"
          id="base-data-special-appliance"
          placeholder="-Select-">
          <ng-template let-item pTemplate="selectedItem">
            <span class="drop-item-label">{{ 'lookup.' + specialApplianceKey + '.options.' + item['value'] + '.name' | translate }}</span>
          </ng-template>
          <ng-template let-option pTemplate="item">
            <div class="drop-item">
              <span class="drop-item-label">
                {{ 'lookup.' + specialApplianceKey + '.options.' + option['value'] + '.name' | translate }}
              </span>
            </div>
          </ng-template>
        </p-dropdown>
      </div>
      <div *ngIf="specialApplianceType === 'wallbox' || specialApplianceType === 'charger'" class="ui-g-5">
        <div class="ui-g-6">
          <p-checkbox
            binary="true"
            [readonly]="isReadOnly"
            formControlName="consumptionDeviceCheckbox"
            id="base-data-consumption-device-check"
            label="{{ 'facilities-data.form-fields.consumption-device-checkbox' | translate }}"></p-checkbox>
        </div>

        <div class="ui-g-6">
          <p-checkbox
            binary="true"
            [readonly]="isReadOnly"
            formControlName="publicDeviceCheckbox"
            id="base-data-public-device-check"
            label="{{ 'facilities-data.form-fields.public-device-checkbox' | translate }}"></p-checkbox>
        </div>
      </div>
      <div
        *ngIf="specialApplianceType !== 'wallbox' && specialApplianceType !== 'charger' && specialApplianceType !== 'other'"
        class="ui-g-5"></div>

      <div class="top-right-position padding-top-1" *ngIf="!isReadOnly && displayDeleteButton">
        <div class="pi pi-trash pointer-cursor" (click)="removeElement()"></div>
      </div>
    </div>
    <div class="ui-g-12 form-rows" *ngIf="specialApplianceType === 'other'">
      <div class="ui-g-6 field-rows">
        <label for="base-data-other-appliance" class="ui-g-6 field-label text-right-align"></label>
        <input
          id="base-data-other-appliance"
          class="ui-input pInputText"
          formControlName="other_appliance"
          [readonly]="isReadOnly"
          pInputText />
      </div>
    </div>

    <div class="ui-g-12 form-rows" *ngIf="specialApplianceFG.get('blockIntervals') && specialApplianceType === 'heatpump'">
      <div class="ui-g-6 field-rows">
        <label class="ui-g-6 field-label text-right-align" for="base-data-block-intervals">
          {{ 'facilities-data.form-fields.block-intervals' | translate }}
        </label>
        <p-dropdown
          [options]="blockIntervals"
          formControlName="blockIntervals"
          [readonly]="isReadOnly"
          id="base-data-block-intervals"
          placeholder="-Select-">
          <ng-template let-item pTemplate="selectedItem">
            <span class="drop-item-label">{{ 'lookup.' + blockIntervalsKey + '.options.' + item['value'] + '.name' | translate }}</span>
          </ng-template>
          <ng-template let-option pTemplate="item">
            <div class="drop-item">
              <span class="drop-item-label">{{ 'lookup.' + blockIntervalsKey + '.options.' + option['value'] + '.name' | translate }}</span>
            </div>
          </ng-template>
        </p-dropdown>
      </div>
    </div>

    <div class="ui-g-12 form-rows" *ngIf="showAdditionalData">
      <ng-container *ngIf="!environmentService.copyExistingTechnicalDataConfiguration">
        <div class="ui-g-6 field-rows">
          <label class="ui-g-6 field-label text-right-align" [class.required]="isSpecialApplianceSectionRequired" for="base-data-type">
            {{ 'facilities-data.form-fields.type' | translate }}
          </label>
          <input
            class="ui-input pInputText"
            formControlName="typeName"
            id="base-data-type"
            pInputText
            size="30"
            type="text"
            [readonly]="isReadOnly" />
        </div>
      </ng-container>
      <div class="ui-g-6 field-rows">
        <label class="ui-g-6 field-label text-right-align" [class.required]="isSpecialApplianceSectionRequired" for="base-data-amount">
          {{ 'facilities-data.form-fields.amount' | translate }}
        </label>
        <input
          [class]="!environmentService.copyExistingTechnicalDataConfiguration ? 'ui-input pInputText small-width' : 'ui-input pInputText'"
          formControlName="amount"
          id="base-data-amount"
          maxlength="5"
          type="number"
          pInputText
          size="30"
          [readonly]="isReadOnly" />
      </div>
    </div>

    <div class="ui-g-12 form-rows">
      <ng-container *ngIf="showAdditionalData && !environmentService.copyExistingTechnicalDataConfiguration">
        <div class="ui-g-6 field-rows">
          <label
            class="ui-g-6 field-label text-right-align"
            [class.required]="isSpecialApplianceSectionRequired"
            for="base-data-manufacturer">
            {{ 'facilities-data.form-fields.manufacturer' | translate }}
          </label>
          <input
            class="ui-input pInputText"
            formControlName="manufacturer"
            id="base-data-manufacturer"
            pInputText
            size="30"
            type="text"
            [readonly]="isReadOnly" />
        </div>
      </ng-container>

      <div class="ui-g-6 field-rows">
        <label class="ui-g-6 field-label text-right-align" [class.required]="isSpecialApplianceSectionRequired" for="base-data-power">
          {{ 'facilities-data.form-fields.power' | translate }}
        </label>
        <input
          appFloatNumber="2"
          [class]="!environmentService.copyExistingTechnicalDataConfiguration ? 'ui-input pInputText small-width' : 'ui-input pInputText'"
          formControlName="power"
          id="base-data-power"
          pInputText
          [readonly]="isReadOnly" />
        <span class="unit-margin">{{ allUnits.power }}</span>
      </div>
    </div>
    <div *ngIf="showSubjectToApprovalCheckbox && subjectToApprovalRequirementsMet" class="ui-g-12 form-rows">
      <div class="ui-g-10 text-right-align">
        <p-checkbox
          binary="true"
          [readonly]="isReadOnly"
          formControlName="deviceRequiresApproval"
          id="Subject-to=approval"
          label="{{ 'facilities-data.form-fields.device-subject-to-approval' | translate }}"></p-checkbox>
      </div>
    </div>
  </div>
</form>
